(function () {
  // =========================
  // Cookies helpers
  // =========================
  function setCookie(name, value, minutes) {
    let expires = "";
    if (minutes) {
      const date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
  }

  // =========================
  // Utils
  // =========================
  function generateUniqueAlphaNumericCode(length) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let code = "";
    for (let i = 0; i < length; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return code;
  }

  var COOKIE_MINUTES = 129600; // 90 días
  var UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  var ADS_PARAMS = ["gclid", "gbraid", "wbraid", "gad_source", "gad_campaignid", "fbclid", "ttclid"];
  var TRACKING_PARAMS = UTM_PARAMS.concat(ADS_PARAMS);

  function hasTrackingParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    return TRACKING_PARAMS.some(function (param) { return urlParams.has(param); });
  }

  // Punto 2: extrae gclid/gbraid/wbraid/utm_* de una URL como campos propios
  function getClickParams(url) {
    var out = {};
    TRACKING_PARAMS.forEach(function (k) { out[k] = ""; });
    if (!url) return out;
    try {
      var p = new URL(url, window.location.origin).searchParams;
      TRACKING_PARAMS.forEach(function (k) { out[k] = p.get(k) || ""; });
    } catch (e) { /* URL malformada → campos vacíos */ }
    return out;
  }

  // 04.1: respaldo con las cookies de Google/Meta cuando la URL no trae el click ID.
  // _gcl_aw = "GCL.<ts>.<gclid>", _gcl_gb = "GCL.<ts>.<gbraid>", _fbc = "fb.1.<ts>.<fbclid>"
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid'];

  function cookiePart(name, index) {
    var v = getCookie(name);
    if (!v) return "";
    try { v = decodeURIComponent(v); } catch (e) {}
    return v.split(".")[index] || "";
  }

  // Solo se usa si la URL trae parámetros (página de anuncio) pero NINGÚN click ID
  // (p. ej. solo utm_* o un redirect que quitó el gclid). Si la URL ya trae un click ID
  // (gclid, fbclid…) no se mezcla con cookies de otro anuncio/plataforma.
  function withCookieFallback(params) {
    params.click_id_source = "";
    if (CLICK_IDS.some(function (k) { return params[k]; })) {
      params.click_id_source = "url";
      return params;
    }
    var fromCookie = [
      ["gclid", cookiePart("_gcl_aw", 2), "_gcl_aw"],
      ["gbraid", cookiePart("_gcl_gb", 2), "_gcl_gb"],
      ["fbclid", cookiePart("_fbc", 3), "_fbc"]
    ];
    var used = [];
    fromCookie.forEach(function (c) {
      if (c[1]) { params[c[0]] = c[1]; used.push(c[2]); }
    });
    if (used.length) params.click_id_source = "cookie:" + used.join(",");
    return params;
  }

  // Hash corto (djb2) para comparar URLs sin guardarlas completas en otra cookie
  function hashString(s) {
    var h = 5381;
    for (var i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
    return (h >>> 0).toString(36);
  }

  // La URL del anuncio solo cuenta en la página que TRAE parámetros (gclid, utm_*…).
  // Si el cliente navega a otra página sin parámetros, ya no hay URL ni código.
  function currentAdUrl() {
    return hasTrackingParameters() ? window.location.href : null;
  }

  // v3: URL del ÚLTIMO anuncio por el que entró el cliente (se reemplaza con cada anuncio
  // nuevo y vive lo mismo que el código). Sirve para mandar la fila de tracking con su
  // anuncio/gclid aunque el cliente escriba desde otra página o regrese después.
  var AD_URL_COOKIE = "lastAdUrl";

  function savedAdUrl() {
    var v = getCookie(AD_URL_COOKIE);
    if (!v) return null;
    try { return decodeURIComponent(v); } catch (e) { return null; }
  }

  // ¿ESTA visita llegó por publicidad? Se decide cada vez que el cliente ENTRA al sitio
  // desde fuera (dirección escrita, Google orgánico, favorito, otra web…):
  //   - entra con parámetros → visita por publicidad
  //   - entra sin parámetros → visita orgánica (aunque antes haya entrado por un anuncio)
  // Al navegar dentro del sitio (producto → producto) se conserva lo decidido al entrar.
  var AD_VISIT_COOKIE = "adVisit";

  function cameFromThisSite() {
    try { return !!document.referrer && new URL(document.referrer).host === window.location.host; }
    catch (e) { return false; }
  }

  if (hasTrackingParameters()) {
    setCookie(AD_URL_COOKIE, encodeURIComponent(window.location.href), COOKIE_MINUTES);
    setCookie(AD_VISIT_COOKIE, "1");
  } else if (!cameFromThisSite()) {
    setCookie(AD_VISIT_COOKIE, "0");
  }

  function isAdVisit() {
    return hasTrackingParameters() || getCookie(AD_VISIT_COOKIE) === "1";
  }

  // Código que se muestra y se manda: "NBSP-" (visita por publicidad) o "NBSO-" (visita
  // orgánica) + los 8 caracteres del cliente. La cookie guarda el código base (NBSXXXXXXXX),
  // así el mismo cliente conserva sus 8 caracteres y solo cambia la P/O según cómo entró.
  function displayCode(saved) {
    if (!saved) return null;
    var base = String(saved).replace(/^NBS(-[PO]|[PO]-)?/, "");
    return "NBS" + (isAdVisit() ? "P" : "O") + "-" + base;
  }

  // =========================
  // Region / Market config (solo MX)
  // =========================
  function getRegionConfig() {
    return {
      region: "MX",
      phone: "5213315289038",
      sheetUrl:
        "https://script.google.com/macros/s/AKfycbySqCr2RMB90m82RKiEpfzeoUo81MhGyCmVrDBx1IzaCZ6Q600uhw8dgPIB7JNXx52aEQ/exec",
      // "Promoción NBSP-…/NBSO-…" (el mismo código que se manda a la hoja)
      makeBaseMessage: function (cleanURL, savedID) {
        if (savedID) {
          return "Promoción " + savedID + " ¡Hola! Nogal Beat, tengo una duda, me puedes ayudar con el siguiente producto: " + cleanURL;
        }
        return "¡Hola! Nogal Beat, tengo una duda, me puedes ayudar con el siguiente producto: " + cleanURL;
      },
    };
  }

  // =========================
  // Promo data (cookies) — scoped by region
  // =========================
  function getOrCreatePromoData(region) {
    var urlKey = "urlWithUTM_" + region;
    var idKey = "uniqueID_" + region;

    // Se borran las cookies de URL de versiones anteriores para no arrastrar anuncios viejos
    deleteCookie(urlKey);
    deleteCookie("urlWithUTM");

    var savedUrl = null;
    var savedID = getCookie(idKey);

    // Todo visitante recibe código, entre por publicidad u orgánico (NBSP-… / NBSO-…).
    // Mientras la cookie siga viva (90 días desde que se creó) se conservan sus 8 caracteres
    // aunque después entre por un anuncio u orgánico. Solo se genera uno nuevo si no hay
    // cookie (primera visita o ya expiró).
    if (!savedID) {
      savedID = "NBS" + generateUniqueAlphaNumericCode(8);
      setCookie(idKey, savedID, COOKIE_MINUTES);
    }

    if (hasTrackingParameters()) {
      // La URL es la de ESTA página con parámetros
      savedUrl = window.location.href;
    }

    return { savedUrl: savedUrl, savedID: savedID, idKey: idKey };
  }

  // =========================
  // 04.2: envío a la hoja con confirmación, reintentos y cola
  // El Apps Script responde {ok:true}. Si falla (red, error del script, sin respuesta),
  // el envío queda en localStorage y se reintenta: 2 s y 10 s después en la misma página,
  // y en las siguientes visitas (hasta 7 días / 6 intentos). Cada envío lleva event_id
  // para que el Apps Script no duplique la fila si un reintento llega dos veces.
  // =========================
  var QUEUE_KEY = "ks_sheet_queue";
  var RETRY_DELAYS = [2000, 10000];
  var MAX_ATTEMPTS = 6;
  var QUEUE_MAX_AGE = 7 * 24 * 60 * 60 * 1000;

  function readQueue() {
    try { return JSON.parse(localStorage.getItem(QUEUE_KEY)) || []; } catch (e) { return []; }
  }

  function writeQueue(q) {
    try {
      if (q.length) localStorage.setItem(QUEUE_KEY, JSON.stringify(q));
      else localStorage.removeItem(QUEUE_KEY);
    } catch (e) {}
  }

  function saveInQueue(item) {
    var q = readQueue().filter(function (i) { return i.data.event_id !== item.data.event_id; });
    q.push(item);
    writeQueue(q);
  }

  function removeFromQueue(eventId) {
    writeQueue(readQueue().filter(function (i) { return i.data.event_id !== eventId; }));
  }

  // text/plain = petición simple (sin preflight), así Google deja leer la respuesta
  function postToSheet(sheetUrl, data) {
    return fetch(sheetUrl, {
      method: "POST",
      keepalive: true, // v6: el envío sobrevive si la página se va a WhatsApp
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify(data),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (res) {
        if (!res || res.ok !== true) throw new Error((res && res.error) || "respuesta sin ok");
        return res;
      });
  }

  function trySend(item) {
    item.attempts++;
    item.data.attempt = item.attempts;
    saveInQueue(item); // queda guardado hasta que el Apps Script confirme
    return postToSheet(item.url, item.data)
      .then(function () {
        removeFromQueue(item.data.event_id);
        return true;
      })
      .catch(function (err) {
        item.data.last_error = String((err && err.message) || err).slice(0, 200);
        saveInQueue(item);
        return false;
      });
  }

  // Misma firma que antes (sheetUrl, data): la URL viene de getRegionConfig()
  function sendDataToGoogleSheets(sheetUrl, data) {
    data.event_id = Date.now().toString(36) + "-" + generateUniqueAlphaNumericCode(8);
    var item = { url: sheetUrl, data: data, attempts: 0, created: Date.now() };
    var retry = 0;
    (function attempt() {
      trySend(item).then(function (ok) {
        if (!ok && retry < RETRY_DELAYS.length && item.attempts < MAX_ATTEMPTS) {
          setTimeout(attempt, RETRY_DELAYS[retry++]);
        }
      });
    })();
  }

  // Reintenta lo que quedó pendiente de visitas anteriores
  function flushQueue() {
    var now = Date.now();
    var q = readQueue().filter(function (i) {
      return i.url && now - i.created < QUEUE_MAX_AGE && i.attempts < MAX_ATTEMPTS;
    });
    writeQueue(q);
    q.forEach(function (item) { trySend(item); });
  }

  // =========================
  // WhatsApp URL builder
  // =========================
  function buildWhatsAppUrl(baseHref, phone, message) {
    var base = baseHref && /^https?:\/\//i.test(baseHref) && baseHref.includes("whatsapp") ? baseHref : "https://api.whatsapp.com/send";
    var u = new URL(base, window.location.origin);

    u.hostname = "api.whatsapp.com";
    u.pathname = "/send";
    u.searchParams.set("phone", phone);
    u.searchParams.set("text", message);
    u.searchParams.set("type", "phone_number");
    u.searchParams.set("app_absent", "0");

    return u.toString();
  }

  function isWhatsAppAnchor(a) {
    var href = (a.getAttribute("href") || "").toLowerCase();
    var text = (a.textContent || "").toLowerCase();
    var id = (a.id || "").toLowerCase();
    var allowedIds = ["botonwh", "bhws", "button2"];

    return allowedIds.includes(id) || text.includes("whatsapp") || href.includes("whatsapp") || href.includes("wa.me");
  }

  // =========================
  // Modal del formulario
  // =========================
  var pendingWhatsAppUrl = "";
  var currentCfg = null;
  var currentIdKey = "";

  // =========================
  // v6 · Experimento de fricción (tarjeta M6): Nogal Beat Store tiene ventana OBLIGATORIA y
  // sirve de comparación con kitchenmax.mx (K1, ventana opcional). Se registran los mismos
  // pasos en la pestaña "Embudo" de la hoja:
  //   clic_burbuja → ventana_vista → con_datos | cerrada  (aquí no existe "sin datos")
  // Las filas de un mismo intento comparten flujo_id. La ventana funciona igual que antes.
  // =========================
  var flujoId = "";
  var flujoCerrado = true;

  function isMobile() {
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) ? "movil" : "escritorio";
  }

  // Los pasos del embudo se mandan una sola vez, sin cola de reintentos: un paso perdido
  // pesa poco, y reenviarlo días después lo registraría con otra fecha.
  function sendFunnel(data) {
    if (!currentCfg) return;
    data.event_id = Date.now().toString(36) + "-" + generateUniqueAlphaNumericCode(8);
    postToSheet(currentCfg.sheetUrl, data).catch(function () {});
  }

  function logFunnel(paso, extra) {
    try {
      var adUrl = isAdVisit() ? (currentAdUrl() || savedAdUrl()) : null;
      sendFunnel({
        type: "embudo",
        paso: paso,
        flujo_id: flujoId,
        uniqueID: displayCode(getCookie(currentIdKey)) || "",
        pageURL: window.location.href,
        dispositivo: isMobile(),
        origen: (extra && extra.origen) || "",
        // utm_source va aparte para que el Apps Script mande las pruebas del vigilante a su pestaña
        utm_source: getClickParams(adUrl).utm_source || ""
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "wa_embudo", wa_paso: paso, wa_flujo: flujoId });
    } catch (err) { /* el registro nunca bloquea WhatsApp */ }
  }

  // Si el cliente se va de la página con la ventana abierta (botón atrás, cerrar pestaña),
  // cuenta como "cerrada"; sin esto el abandono en celular quedaría sin registrar.
  window.addEventListener("pagehide", function () {
    if (flujoId && !flujoCerrado) { flujoCerrado = true; logFunnel("cerrada"); }
  });

  function createFormModal() {
    var style = document.createElement("style");
    style.textContent = "\
      #wa-form-overlay {\
        display: none;\
        position: fixed;\
        top: 0; left: 0; right: 0; bottom: 0;\
        background: rgba(0,0,0,0.55);\
        z-index: 99999;\
        align-items: center;\
        justify-content: center;\
      }\
      #wa-form-overlay.active {\
        display: flex;\
      }\
      #wa-form-modal {\
        background: #fff;\
        border-radius: 12px;\
        padding: 28px 24px 20px;\
        max-width: 400px;\
        width: 90%;\
        box-shadow: 0 8px 32px rgba(0,0,0,0.25);\
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\
        position: relative;\
      }\
      #wa-form-modal h3 {\
        margin: 0 0 6px;\
        font-size: 20px;\
        color: #128C7E;\
        text-align: center;\
      }\
      #wa-form-modal p.wa-form-desc {\
        margin: 0 0 18px;\
        font-size: 14px;\
        color: #555;\
        text-align: center;\
      }\
      #wa-form-modal label {\
        display: block;\
        font-size: 13px;\
        font-weight: 600;\
        color: #333;\
        margin-bottom: 4px;\
      }\
      #wa-form-modal input {\
        width: 100%;\
        padding: 10px 12px;\
        margin-bottom: 14px;\
        border: 1px solid #ccc;\
        border-radius: 8px;\
        font-size: 15px;\
        box-sizing: border-box;\
        transition: border-color 0.2s;\
      }\
      #wa-form-modal input:focus {\
        outline: none;\
        border-color: #25D366;\
        box-shadow: 0 0 0 2px rgba(37,211,102,0.15);\
      }\
      #wa-form-modal input.wa-input-error {\
        border-color: #e53e3e;\
      }\
      #wa-form-modal .wa-error-msg {\
        color: #e53e3e;\
        font-size: 12px;\
        margin: -10px 0 10px;\
        display: none;\
      }\
      #wa-form-submit {\
        width: 100%;\
        padding: 12px;\
        background: #25D366;\
        color: #fff;\
        border: none;\
        border-radius: 8px;\
        font-size: 16px;\
        font-weight: 600;\
        cursor: pointer;\
        transition: background 0.2s;\
      }\
      #wa-form-submit:hover {\
        background: #128C7E;\
      }\
      #wa-form-close {\
        position: absolute;\
        top: 10px; right: 14px;\
        background: none;\
        border: none;\
        font-size: 22px;\
        cursor: pointer;\
        color: #888;\
        line-height: 1;\
      }\
      #wa-form-close:hover {\
        color: #333;\
      }\
      .custom-wa-message_text{\
        position: absolute;\
        left: -9999px;\
        top: -9999px;\
        width: 1px;\
        height: 1px;\
        overflow: hidden;\
      }\
      .wa-privacy-notice{\
      font-size: 11px;\
      color: #777;\
      margin: 0 0 14px;\
      line-height: 1.45;\
      text-align: center;\
      }\
      .wa-privacy-notice a{\
        color: #128C7E;\
        text-decoration: underline;\
      }\
    ";
    document.head.appendChild(style);

    var overlay = document.createElement("div");
    overlay.id = "wa-form-overlay";
    overlay.innerHTML = '\
      <div id="wa-form-modal">\
        <button id="wa-form-close" type="button" aria-label="Cerrar">&times;</button>\
        <h3>Contáctanos por WhatsApp</h3>\
        <p class="wa-form-desc">Completa tus datos para brindarte una mejor atención.</p>\
        <form id="wa-contact-form" novalidate autocomplete="on">\
          <label for="wa-phone">Número de WhatsApp *</label>\
          <input type="tel" id="wa-phone" name="phone" data-gtm-field="phone" placeholder="Ej: 3312345678" maxlength="10" inputmode="numeric" pattern="[0-9]*" required autocomplete="tel">\
          <div class="wa-error-msg" id="wa-phone-error">Ingresa un número de 10 dígitos.</div>\
          <label for="wa-email">Correo electrónico *</label>\
          <input type="email" id="wa-email" name="email" data-gtm-field="email" placeholder="tu@correo.com" autocomplete="email">\
          <div class="wa-error-msg" id="wa-email-error">Por favor ingresa un correo válido.</div>\
          <label for="wa-message_text"></label>\
          <input type="text" tabindex="-1" aria-hidden="true" id="wa-message_text" autocomplete="off" name="wa-message_text" class="custom-wa-message_text">\
          <button type="submit" id="wa-form-submit">Enviar y abrir WhatsApp</button>\
          <p class="wa-privacy-notice">Al enviar, autorizas el tratamiento de tus datos personales conforme a nuestro <a href="/policies/privacy-policy" target="_blank" rel="noopener">Aviso de Privacidad</a>, incluido su uso para medición y mejora de nuestras campañas publicitarias.</p>\
        </form>\
      </div>\
    ';
    document.body.appendChild(overlay);

    document.getElementById("wa-form-close").addEventListener("click", function () { closeFormModal(true); });
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeFormModal(true);
    });

    document.getElementById("wa-contact-form").addEventListener("submit", function (e) {
      e.preventDefault();
      handleFormSubmit();
    });

    // Solo permitir números en el campo de teléfono
    document.getElementById("wa-phone").addEventListener("input", function () {
      this.value = this.value.replace(/\D/g, "").slice(0, 10);
    });
  }

  function openFormModal(whatsappUrl, origen) {
    pendingWhatsAppUrl = whatsappUrl;
    flujoId = Date.now().toString(36) + "-" + generateUniqueAlphaNumericCode(6);
    flujoCerrado = false;
    logFunnel("clic_burbuja", { origen: origen });
    var overlay = document.getElementById("wa-form-overlay");
    if (overlay) {
      overlay.classList.add("active");
      // "vista" solo si la ventana quedó visible de verdad
      var esteFlujo = flujoId;
      requestAnimationFrame(function () {
        if (flujoId === esteFlujo && !flujoCerrado && getComputedStyle(overlay).display !== "none") logFunnel("ventana_vista");
      });
      var form = document.getElementById("wa-contact-form");
      if (form) form.reset();
      clearErrors();
    }
  }

  // abandono = true cuando el cliente cierra la ventana sin enviar (X o clic fuera)
  function closeFormModal(abandono) {
    var overlay = document.getElementById("wa-form-overlay");
    if (overlay) overlay.classList.remove("active");
    if (abandono === true && !flujoCerrado) logFunnel("cerrada");
    flujoCerrado = true;
    pendingWhatsAppUrl = "";
  }

  function clearErrors() {
    var inputs = document.querySelectorAll("#wa-form-modal input");
    inputs.forEach(function (input) { input.classList.remove("wa-input-error"); });
    var msgs = document.querySelectorAll("#wa-form-modal .wa-error-msg");
    msgs.forEach(function (msg) { msg.style.display = "none"; });
  }

  function showFieldError(fieldId, errorId) {
    var field = document.getElementById(fieldId);
    var error = document.getElementById(errorId);
    if (field) field.classList.add("wa-input-error");
    if (error) error.style.display = "block";
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function handleFormSubmit() {
    clearErrors();

    var wa_message = (document.getElementById("wa-message_text").value).trim(); //Wa-Message
    if(isHoneypotFilled(wa_message)){
      logFunnel("trampa");
      flujoCerrado = true; // un solo final por intento
      createReport();
      return;
    }

    var email = (document.getElementById("wa-email").value || "").trim();
    var phone = (document.getElementById("wa-phone").value || "").trim();

    var valid = true;
    var phoneDigits = phone.replace(/\D/g, "");
    if (!phoneDigits || phoneDigits.length !== 10) { showFieldError("wa-phone", "wa-phone-error"); valid = false; }
    if (!email || !isValidEmail(email)) { showFieldError("wa-email", "wa-email-error"); valid = false; }

    if (!valid) return;

    logFunnel("con_datos"); // v6: embudo

    var finalURL = window.location.href;
    var urlWithUTM = currentAdUrl(); // URL con parámetros de ESTA página (o null)
    var adUrl = urlWithUTM || savedAdUrl(); // v3: anuncio por el que entró (esta página o la cookie)
    // v3: el código de la cookie (90 días desde el primer anuncio) se usa SIEMPRE, aunque
    // el cliente escriba desde otra página o regrese después. La fila de tracking va con la URL
    // del último anuncio (adUrl); en Contactos, URL+UTM = anuncio (distinta de URL = escribió desde otra página).
    var clickID = displayCode(getCookie(currentIdKey)); // NBSP-… (publicidad) / NBSO-… (orgánico)
    var clickParams = getClickParams(adUrl); // Punto 2: gclid/gbraid/wbraid/utm_* como campos propios
    if (adUrl) withCookieFallback(clickParams); // 04.1: respaldo _gcl_aw / _gcl_gb / _fbc

    // Enviar tracking UTM a la hoja principal solo si hay UTM, y una sola vez por
    // código + URL de anuncio (las cookies ya no se borran → evita filas duplicadas;
    // si llegó por un anuncio nuevo, sí se manda una fila con el nuevo gclid)
    var sentCookie = "uniqueIDSent_" + currentCfg.region;
    var sentKey = clickID + "|" + hashString(adUrl || "");
    if (clickID && adUrl && isAdVisit() && getCookie(sentCookie) !== sentKey) {
      sendDataToGoogleSheets(currentCfg.sheetUrl, Object.assign({
        region: currentCfg.region,
        uniqueID: clickID,
        urlWithUTM: adUrl,
        finalURL: finalURL
      }, clickParams));
      setCookie(sentCookie, sentKey, COOKIE_MINUTES);
    }

    // Enviar datos del cliente a la hoja "Contactos"
    sendDataToGoogleSheets(currentCfg.sheetUrl, Object.assign({
      type: "contacto",
      contactEmail: email,
      contactPhone: phone,
      pageURL: finalURL,
      uniqueID: clickID || "",
      // URL+UTM y gclid/utm_*… solo si ESTA visita viene de publicidad; visita orgánica → vacíos
      urlWithUTM: isAdVisit() ? (adUrl || "") : ""
    }, isAdVisit() ? clickParams : getClickParams(null)));

    // Punto 3: la cookie del código ya NO se borra tras el lead.
    // Vive sus 90 días para que los siguientes contactos del mismo cliente conserven el código.

    // Enhanced Conversions for Leads — enviar user_data por gtag y dataLayer
    var phoneNormalized = '+52' + phoneDigits;
    var emailNormalized = email ? email.toLowerCase().trim() : '';
    var userData = { phone_number: phoneNormalized };
    if (emailNormalized) { userData.email = emailNormalized; }

    // Push al dataLayer para GTM y consumidores de auto-detect
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'lead_submitted',
      enhanced_conversion_data: userData
    });

    if (typeof gtag === 'function') {
      // Set global de user_data (persiste en la sesión)
      gtag('set', 'user_data', userData);

      // Conversion con user_data inline (forma robusta documentada por Google) (Deprecado por Alvaro 2026-07-15)
      //gtag('event', 'conversion', {
      //  'send_to': 'AW-16459972940/0XWZCPaIyJ0cEMyC3ag9',
      //  'value': 1.0,
      //  'currency': 'MXN',
      //  'user_data': userData
      //});
    }

    // Link armado al momento del envío con el MISMO código que se mandó a la hoja
    var cleanURL = window.location.origin + window.location.pathname;
    var url = buildWhatsAppUrl(pendingWhatsAppUrl, currentCfg.phone, currentCfg.makeBaseMessage(cleanURL, clickID));
    closeFormModal(false);
    // v6: navegadores dentro de Instagram/Facebook o con bloqueo de ventanas pueden no abrir
    // la pestaña nueva: en ese caso se va a WhatsApp en la misma pestaña.
    // Dentro de Instagram/Facebook se va directo (ahí window.open puede "funcionar" sin abrir nada).
    var inApp = /FBAN|FBAV|Instagram/i.test(navigator.userAgent);
    var w = null;
    if (!inApp) { try { w = window.open(url, "_blank"); } catch (err) {} }
    if (!w) window.location.href = url;
  }

  // =========================
  // 04.5: clic en un link de correo (mailto:) → fila en la pestaña "Correos" de la hoja,
  // con el mismo código NBSP-/NBSO- y la misma regla de campaña que el formulario:
  // datos del anuncio solo si ESTA visita viene de publicidad. El correo se abre normal.
  // Una sola fila por código + correo + página (varios clics seguidos no duplican).
  // =========================
  function handleEmailClick(a) {
    try {
      if (!currentCfg) return;
      var destino = (a.getAttribute("href") || "").replace(/^mailto:/i, "").split("?")[0].trim().toLowerCase();
      var code = displayCode(getCookie(currentIdKey));
      var adUrl = isAdVisit() ? (currentAdUrl() || savedAdUrl()) : null;
      var pagina = window.location.origin + window.location.pathname;
      var key = (code || "") + "|" + hashString(destino + "|" + pagina);
      if (getCookie("correoSent") === key) return;

      var params = getClickParams(adUrl);
      if (adUrl) withCookieFallback(params);
      sendDataToGoogleSheets(currentCfg.sheetUrl, Object.assign({
        type: "correo",
        uniqueID: code || "",
        emailTo: destino,
        pageURL: window.location.href,
        urlWithUTM: adUrl || ""
      }, params));
      setCookie("correoSent", key, COOKIE_MINUTES);
    } catch (err) { /* nunca bloquear el link de correo */ }
  }

  // =========================
  // Cargar y crear reporte de bot/explorador
  // =========================

  function sendReportToGoogleSheets(data){
    fetch(
      'https://script.google.com/macros/s/AKfycbwPDcVUp1z9k1LntcKBD-qyd770ROHzB-mMV_42mPCia6Sfktq75fMgG8wpgVJyC96h/exec',
      {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }

    )
  }

  async function createReport(){
    var temp_data = await getDatafromAPI() || "unknown";
    var userID = getClarityInfoCookie("_clck");
    var sessionID = getClarityInfoCookie("_clsk");
    var location = getCookie("localization");
    var savedUrl = currentAdUrl() || "unknown";
    var page_location = window.location.href;

    sendReportToGoogleSheets({
      type: "reporte",
      temp: temp_data,
      location : location,
      web_source: savedUrl,
      clarity_id: userID,
      clarity_session: sessionID,
      page_location : page_location,
    });
    return;
  }

  async function getDatafromAPI(){
    try {
      const response = await fetch("https://api.ipify.org/?format=json");
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error("Error obteniendo información:", error);
      return null;
    }
  }

  function isHoneypotFilled(honeypot) {
    return honeypot !== "";
  }

  function getClarityInfoCookie(cookie_value) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === cookie_value) {
            // El Session ID es la primera parte antes del primer ^
            const decoded = decodeURIComponent(value);
            return decoded.split('^')[0];
        }
    }
    return "Unknown";
  }



  // =========================
  // Popup lógica (salida + inactividad)
  // =========================
  var popupShown = false;
  var inactivityTimer;

  function showPopup() {
    var popup = document.getElementById("popupWhatsApp");
    if (!popup) return;

    if (!popupShown) {
      popup.classList.add("show");
      popupShown = true;

      setTimeout(function () {
        popup.classList.remove("show");
        popupShown = false;
      }, 15000);
    }
  }

  document.addEventListener("mouseleave", function (e) {
    if (!popupShown && window.innerWidth > 768 && e.clientY < 10) showPopup();
  });

  function resetInactivityTimer() {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(function () {
      if (!popupShown) showPopup();
    }, 30000);
  }

  ["mousemove", "keydown", "scroll", "touchstart"].forEach(function (evt) {
    document.addEventListener(evt, resetInactivityTimer, { passive: true });
  });

  resetInactivityTimer();

  // =========================
  // Inicialización DOM
  // =========================
  function init() {
    var cfg = getRegionConfig();
    flushQueue(); // 04.2: envíos pendientes de visitas anteriores
    var promoData = getOrCreatePromoData(cfg.region);

    // Guardar config para uso en handleFormSubmit
    currentCfg = cfg;
    currentIdKey = promoData.idKey;

    // Mensaje inicial del href (respaldo). El definitivo se arma en handleFormSubmit.
    var cleanURL = window.location.origin + window.location.pathname;
    var message = cfg.makeBaseMessage(cleanURL, displayCode(promoData.savedID)); // v3: código siempre (NBSP-/NBSO-)

    // Crear el modal del formulario
    createFormModal();

    // 1) Link del popup (si existe)
    var waDynamic = document.getElementById("whatsapp-dynamic");
    if (waDynamic) {
      waDynamic.href = buildWhatsAppUrl(waDynamic.getAttribute("href"), cfg.phone, message);
      waDynamic.setAttribute("target", "_blank");
      waDynamic.setAttribute("rel", "noopener");
    }

    // 2) Cualquier link WhatsApp que ya esté en la página: actualiza href (respaldo)
    document.querySelectorAll("a").forEach(function (a) {
      if (!isWhatsAppAnchor(a)) return;
      a.href = buildWhatsAppUrl(a.getAttribute("href"), cfg.phone, message);
    });

    // 3) 04.4: un solo escucha en la página intercepta el clic en CUALQUIER link de
    // WhatsApp, también los que aparecen después de cargar (popups, menú móvil, apps),
    // y muestra el formulario en vez de ir directo a WhatsApp.
    document.addEventListener("click", function (e) {
      var a = e.target instanceof Element ? e.target.closest("a") : null;
      if (a && /^mailto:/i.test(a.getAttribute("href") || "")) { handleEmailClick(a); return; } // 04.5: correo (no se bloquea)
      if (!a || !isWhatsAppAnchor(a)) return;
      if (a.closest("#wa-form-overlay")) return; // links dentro del propio formulario
      e.preventDefault();
      e.stopPropagation();
      openFormModal(a.href, a.id || ""); // id del botón (los ids de sección del tema cambian)
    }, { capture: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
